<template>
<div class="chapter">
<div class="inner_page">
<p class="sp" id="ch4"> </p>
<p class="CH"><span class="ePub-I">CHAPTER</span></p>
<p class="CN"><span class="ePub-I">FOUR</span></p>
<p class="CO">Evan stumbled across Medipharm Corporation while thumbing through a copy of the <span class="ePub-I">Journal of the American Medical Association</span> that he randomly snagged from a recycling stack on the curb near his apartment. <span class="ePub-I">Thank you, Tess McGill. You never know where the next great idea will come from.</span></p>
<p class="TX">As an assistant analyst, Evan crunched numbers and reviewed SEC bullshit. He wasn’t expected to pursue new business, but when he noticed the words “promising new drug” in a footnote, a little research was in order.</p>
<p class="TX">Medipharm had been a private company until six months ago when it merged with an inactive public shell. Hidden in Kentucky at the University of Louisville’s respected biomedical incubator, Medipharm was overlooked. If ECM picked up coverage, it would be the first. Evan saw an opportunity to make a market in an unknown pharmaceutical company. He would write a research report touting Medipharm and recommending that people buy its stock. ECM’s investment bankers would advise the company on transactions and when to offer and sell new stock. And ECM’s traders would buy and sell Medipharm’s stock for themselves and customers, collecting a commission with every trade. So many opportunities, and, for Evan, an opportunity to make millions.</p>
<p class="SB-STD">*   *   *</p>
<p class="SB1-NOSPACE">“<span class="ePub-I">Where</span> are you flying off to?”</p>
<p class="TX">Evan didn’t have any friends, any <span class="ePub-I">real</span> friends, but his neighbor Fleur came pretty close. They sat on the stoop of their five-story walk-up, enjoying the last fifteen minutes of the evening’s summer sunshine.</p>
<p class="TX">“Kentucky. Louisville. The place with the Derby.”</p>
<p class="TX">“Why again, Eee-van?” Evan loved Fleur’s Kiwi accent.</p>
<p class="TX">“To check out the company, kick the proverbial tires, and meet with the CEO.” Evan anticipated the next question and continued with barely a pause.</p>
<p class="TX">“Medipharm. It’s a young pharmaceutical company, developing a new drug to treat Alzheimer’s disease.”</p>
<p class="TX">“That’s excellent. My great-aunt died from Alzheimer’s five years ago. I hope your company can help find a cure.”</p>
<p class="TX">Evan said “Indeed, I do too” and looked to the sky. Against the blue screen he saw himself strolling out of 940 Fifth to a waiting Bentley, hand in hand with a radiant, faceless beauty.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter4.vue?23294fbe